const imageSeoData = [
  {
    "slug": "catholic-designs-scripture-1",
    "title": "Catholic Designs Scripture (1)",
    "verseText": "Catholic Designs Scripture (1)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (1).jpg",
    "alt": "Catholic Designs Scripture (1)",
    "description": "Catholic Designs Scripture (1) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (1)",
    "keywords": "Catholic Designs Scripture (1), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-10",
    "title": "Catholic Designs Scripture (10)",
    "verseText": "Catholic Designs Scripture (10)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (10).jpg",
    "alt": "Catholic Designs Scripture (10)",
    "description": "Catholic Designs Scripture (10) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (10)",
    "keywords": "Catholic Designs Scripture (10), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-11",
    "title": "Catholic Designs Scripture (11)",
    "verseText": "Catholic Designs Scripture (11)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (11).jpg",
    "alt": "Catholic Designs Scripture (11)",
    "description": "Catholic Designs Scripture (11) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (11)",
    "keywords": "Catholic Designs Scripture (11), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-12",
    "title": "Catholic Designs Scripture (12)",
    "verseText": "Catholic Designs Scripture (12)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (12).jpg",
    "alt": "Catholic Designs Scripture (12)",
    "description": "Catholic Designs Scripture (12) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (12)",
    "keywords": "Catholic Designs Scripture (12), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-13",
    "title": "Catholic Designs Scripture (13)",
    "verseText": "Catholic Designs Scripture (13)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (13).jpg",
    "alt": "Catholic Designs Scripture (13)",
    "description": "Catholic Designs Scripture (13) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (13)",
    "keywords": "Catholic Designs Scripture (13), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-14",
    "title": "Catholic Designs Scripture (14)",
    "verseText": "Catholic Designs Scripture (14)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (14).jpg",
    "alt": "Catholic Designs Scripture (14)",
    "description": "Catholic Designs Scripture (14) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (14)",
    "keywords": "Catholic Designs Scripture (14), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-15",
    "title": "Catholic Designs Scripture (15)",
    "verseText": "Catholic Designs Scripture (15)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (15).jpg",
    "alt": "Catholic Designs Scripture (15)",
    "description": "Catholic Designs Scripture (15) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (15)",
    "keywords": "Catholic Designs Scripture (15), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-16",
    "title": "Catholic Designs Scripture (16)",
    "verseText": "Catholic Designs Scripture (16)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (16).jpg",
    "alt": "Catholic Designs Scripture (16)",
    "description": "Catholic Designs Scripture (16) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (16)",
    "keywords": "Catholic Designs Scripture (16), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-17",
    "title": "Catholic Designs Scripture (17)",
    "verseText": "Catholic Designs Scripture (17)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (17).jpg",
    "alt": "Catholic Designs Scripture (17)",
    "description": "Catholic Designs Scripture (17) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (17)",
    "keywords": "Catholic Designs Scripture (17), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-18",
    "title": "Catholic Designs Scripture (18)",
    "verseText": "Catholic Designs Scripture (18)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (18).jpg",
    "alt": "Catholic Designs Scripture (18)",
    "description": "Catholic Designs Scripture (18) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (18)",
    "keywords": "Catholic Designs Scripture (18), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-19",
    "title": "Catholic Designs Scripture (19)",
    "verseText": "Catholic Designs Scripture (19)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (19).jpg",
    "alt": "Catholic Designs Scripture (19)",
    "description": "Catholic Designs Scripture (19) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (19)",
    "keywords": "Catholic Designs Scripture (19), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-2",
    "title": "Catholic Designs Scripture (2)",
    "verseText": "Catholic Designs Scripture (2)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (2).jpg",
    "alt": "Catholic Designs Scripture (2)",
    "description": "Catholic Designs Scripture (2) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (2)",
    "keywords": "Catholic Designs Scripture (2), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-20",
    "title": "Catholic Designs Scripture (20)",
    "verseText": "Catholic Designs Scripture (20)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (20).jpg",
    "alt": "Catholic Designs Scripture (20)",
    "description": "Catholic Designs Scripture (20) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (20)",
    "keywords": "Catholic Designs Scripture (20), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-21",
    "title": "Catholic Designs Scripture (21)",
    "verseText": "Catholic Designs Scripture (21)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (21).jpg",
    "alt": "Catholic Designs Scripture (21)",
    "description": "Catholic Designs Scripture (21) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (21)",
    "keywords": "Catholic Designs Scripture (21), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-22",
    "title": "Catholic Designs Scripture (22)",
    "verseText": "Catholic Designs Scripture (22)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (22).jpg",
    "alt": "Catholic Designs Scripture (22)",
    "description": "Catholic Designs Scripture (22) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (22)",
    "keywords": "Catholic Designs Scripture (22), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-23",
    "title": "Catholic Designs Scripture (23)",
    "verseText": "Catholic Designs Scripture (23)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (23).jpg",
    "alt": "Catholic Designs Scripture (23)",
    "description": "Catholic Designs Scripture (23) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (23)",
    "keywords": "Catholic Designs Scripture (23), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-24",
    "title": "Catholic Designs Scripture (24)",
    "verseText": "Catholic Designs Scripture (24)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (24).jpg",
    "alt": "Catholic Designs Scripture (24)",
    "description": "Catholic Designs Scripture (24) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (24)",
    "keywords": "Catholic Designs Scripture (24), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-25",
    "title": "Catholic Designs Scripture (25)",
    "verseText": "Catholic Designs Scripture (25)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (25).jpg",
    "alt": "Catholic Designs Scripture (25)",
    "description": "Catholic Designs Scripture (25) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (25)",
    "keywords": "Catholic Designs Scripture (25), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-26",
    "title": "Catholic Designs Scripture (26)",
    "verseText": "Catholic Designs Scripture (26)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (26).jpg",
    "alt": "Catholic Designs Scripture (26)",
    "description": "Catholic Designs Scripture (26) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (26)",
    "keywords": "Catholic Designs Scripture (26), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-27",
    "title": "Catholic Designs Scripture (27)",
    "verseText": "Catholic Designs Scripture (27)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (27).jpg",
    "alt": "Catholic Designs Scripture (27)",
    "description": "Catholic Designs Scripture (27) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (27)",
    "keywords": "Catholic Designs Scripture (27), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-28",
    "title": "Catholic Designs Scripture (28)",
    "verseText": "Catholic Designs Scripture (28)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (28).jpg",
    "alt": "Catholic Designs Scripture (28)",
    "description": "Catholic Designs Scripture (28) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (28)",
    "keywords": "Catholic Designs Scripture (28), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-29",
    "title": "Catholic Designs Scripture (29)",
    "verseText": "Catholic Designs Scripture (29)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (29).jpg",
    "alt": "Catholic Designs Scripture (29)",
    "description": "Catholic Designs Scripture (29) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (29)",
    "keywords": "Catholic Designs Scripture (29), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-3",
    "title": "Catholic Designs Scripture (3)",
    "verseText": "Catholic Designs Scripture (3)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (3).jpg",
    "alt": "Catholic Designs Scripture (3)",
    "description": "Catholic Designs Scripture (3) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (3)",
    "keywords": "Catholic Designs Scripture (3), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-30",
    "title": "Catholic Designs Scripture (30)",
    "verseText": "Catholic Designs Scripture (30)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (30).jpg",
    "alt": "Catholic Designs Scripture (30)",
    "description": "Catholic Designs Scripture (30) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (30)",
    "keywords": "Catholic Designs Scripture (30), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-31",
    "title": "Catholic Designs Scripture (31)",
    "verseText": "Catholic Designs Scripture (31)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (31).jpg",
    "alt": "Catholic Designs Scripture (31)",
    "description": "Catholic Designs Scripture (31) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (31)",
    "keywords": "Catholic Designs Scripture (31), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-32",
    "title": "Catholic Designs Scripture (32)",
    "verseText": "Catholic Designs Scripture (32)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (32).jpg",
    "alt": "Catholic Designs Scripture (32)",
    "description": "Catholic Designs Scripture (32) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (32)",
    "keywords": "Catholic Designs Scripture (32), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-33",
    "title": "Catholic Designs Scripture (33)",
    "verseText": "Catholic Designs Scripture (33)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (33).jpg",
    "alt": "Catholic Designs Scripture (33)",
    "description": "Catholic Designs Scripture (33) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (33)",
    "keywords": "Catholic Designs Scripture (33), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-34",
    "title": "Catholic Designs Scripture (34)",
    "verseText": "Catholic Designs Scripture (34)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (34).jpg",
    "alt": "Catholic Designs Scripture (34)",
    "description": "Catholic Designs Scripture (34) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (34)",
    "keywords": "Catholic Designs Scripture (34), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-35",
    "title": "Catholic Designs Scripture (35)",
    "verseText": "Catholic Designs Scripture (35)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (35).jpg",
    "alt": "Catholic Designs Scripture (35)",
    "description": "Catholic Designs Scripture (35) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (35)",
    "keywords": "Catholic Designs Scripture (35), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-36",
    "title": "Catholic Designs Scripture (36)",
    "verseText": "Catholic Designs Scripture (36)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (36).jpg",
    "alt": "Catholic Designs Scripture (36)",
    "description": "Catholic Designs Scripture (36) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (36)",
    "keywords": "Catholic Designs Scripture (36), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-37",
    "title": "Catholic Designs Scripture (37)",
    "verseText": "Catholic Designs Scripture (37)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (37).jpg",
    "alt": "Catholic Designs Scripture (37)",
    "description": "Catholic Designs Scripture (37) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (37)",
    "keywords": "Catholic Designs Scripture (37), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-38",
    "title": "Catholic Designs Scripture (38)",
    "verseText": "Catholic Designs Scripture (38)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (38).jpg",
    "alt": "Catholic Designs Scripture (38)",
    "description": "Catholic Designs Scripture (38) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (38)",
    "keywords": "Catholic Designs Scripture (38), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-39",
    "title": "Catholic Designs Scripture (39)",
    "verseText": "Catholic Designs Scripture (39)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (39).jpg",
    "alt": "Catholic Designs Scripture (39)",
    "description": "Catholic Designs Scripture (39) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (39)",
    "keywords": "Catholic Designs Scripture (39), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-4",
    "title": "Catholic Designs Scripture (4)",
    "verseText": "Catholic Designs Scripture (4)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (4).jpg",
    "alt": "Catholic Designs Scripture (4)",
    "description": "Catholic Designs Scripture (4) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (4)",
    "keywords": "Catholic Designs Scripture (4), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-40",
    "title": "Catholic Designs Scripture (40)",
    "verseText": "Catholic Designs Scripture (40)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (40).jpg",
    "alt": "Catholic Designs Scripture (40)",
    "description": "Catholic Designs Scripture (40) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (40)",
    "keywords": "Catholic Designs Scripture (40), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-41",
    "title": "Catholic Designs Scripture (41)",
    "verseText": "Catholic Designs Scripture (41)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (41).jpg",
    "alt": "Catholic Designs Scripture (41)",
    "description": "Catholic Designs Scripture (41) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (41)",
    "keywords": "Catholic Designs Scripture (41), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-42",
    "title": "Catholic Designs Scripture (42)",
    "verseText": "Catholic Designs Scripture (42)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (42).jpg",
    "alt": "Catholic Designs Scripture (42)",
    "description": "Catholic Designs Scripture (42) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (42)",
    "keywords": "Catholic Designs Scripture (42), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-43",
    "title": "Catholic Designs Scripture (43)",
    "verseText": "Catholic Designs Scripture (43)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (43).jpg",
    "alt": "Catholic Designs Scripture (43)",
    "description": "Catholic Designs Scripture (43) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (43)",
    "keywords": "Catholic Designs Scripture (43), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-44",
    "title": "Catholic Designs Scripture (44)",
    "verseText": "Catholic Designs Scripture (44)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (44).jpg",
    "alt": "Catholic Designs Scripture (44)",
    "description": "Catholic Designs Scripture (44) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (44)",
    "keywords": "Catholic Designs Scripture (44), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-45",
    "title": "Catholic Designs Scripture (45)",
    "verseText": "Catholic Designs Scripture (45)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (45).jpg",
    "alt": "Catholic Designs Scripture (45)",
    "description": "Catholic Designs Scripture (45) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (45)",
    "keywords": "Catholic Designs Scripture (45), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-46",
    "title": "Catholic Designs Scripture (46)",
    "verseText": "Catholic Designs Scripture (46)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (46).jpg",
    "alt": "Catholic Designs Scripture (46)",
    "description": "Catholic Designs Scripture (46) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (46)",
    "keywords": "Catholic Designs Scripture (46), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-47",
    "title": "Catholic Designs Scripture (47)",
    "verseText": "Catholic Designs Scripture (47)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (47).jpg",
    "alt": "Catholic Designs Scripture (47)",
    "description": "Catholic Designs Scripture (47) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (47)",
    "keywords": "Catholic Designs Scripture (47), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-48",
    "title": "Catholic Designs Scripture (48)",
    "verseText": "Catholic Designs Scripture (48)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (48).jpg",
    "alt": "Catholic Designs Scripture (48)",
    "description": "Catholic Designs Scripture (48) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (48)",
    "keywords": "Catholic Designs Scripture (48), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-49",
    "title": "Catholic Designs Scripture (49)",
    "verseText": "Catholic Designs Scripture (49)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (49).jpg",
    "alt": "Catholic Designs Scripture (49)",
    "description": "Catholic Designs Scripture (49) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (49)",
    "keywords": "Catholic Designs Scripture (49), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-5",
    "title": "Catholic Designs Scripture (5)",
    "verseText": "Catholic Designs Scripture (5)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (5).jpg",
    "alt": "Catholic Designs Scripture (5)",
    "description": "Catholic Designs Scripture (5) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (5)",
    "keywords": "Catholic Designs Scripture (5), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-50",
    "title": "Catholic Designs Scripture (50)",
    "verseText": "Catholic Designs Scripture (50)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (50).jpg",
    "alt": "Catholic Designs Scripture (50)",
    "description": "Catholic Designs Scripture (50) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (50)",
    "keywords": "Catholic Designs Scripture (50), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-51",
    "title": "Catholic Designs Scripture (51)",
    "verseText": "Catholic Designs Scripture (51)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (51).jpeg",
    "alt": "Catholic Designs Scripture (51)",
    "description": "Catholic Designs Scripture (51) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (51)",
    "keywords": "Catholic Designs Scripture (51), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-52",
    "title": "Catholic Designs Scripture (52)",
    "verseText": "Catholic Designs Scripture (52)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (52).jpg",
    "alt": "Catholic Designs Scripture (52)",
    "description": "Catholic Designs Scripture (52) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (52)",
    "keywords": "Catholic Designs Scripture (52), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-6",
    "title": "Catholic Designs Scripture (6)",
    "verseText": "Catholic Designs Scripture (6)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (6).jpg",
    "alt": "Catholic Designs Scripture (6)",
    "description": "Catholic Designs Scripture (6) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (6)",
    "keywords": "Catholic Designs Scripture (6), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-7",
    "title": "Catholic Designs Scripture (7)",
    "verseText": "Catholic Designs Scripture (7)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (7).jpg",
    "alt": "Catholic Designs Scripture (7)",
    "description": "Catholic Designs Scripture (7) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (7)",
    "keywords": "Catholic Designs Scripture (7), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-8",
    "title": "Catholic Designs Scripture (8)",
    "verseText": "Catholic Designs Scripture (8)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (8).jpg",
    "alt": "Catholic Designs Scripture (8)",
    "description": "Catholic Designs Scripture (8) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (8)",
    "keywords": "Catholic Designs Scripture (8), Bible verse image, scripture art"
  },
  {
    "slug": "catholic-designs-scripture-9",
    "title": "Catholic Designs Scripture (9)",
    "verseText": "Catholic Designs Scripture (9)",
    "reference": "",
    "shortReference": "",
    "image": "/images/web/scripture/Catholic Designs Scripture (9).jpg",
    "alt": "Catholic Designs Scripture (9)",
    "description": "Catholic Designs Scripture (9) scripture image with Bible verse text.",
    "caption": "Catholic Designs Scripture (9)",
    "keywords": "Catholic Designs Scripture (9), Bible verse image, scripture art"
  }
]

export default imageSeoData;
